/**
 * Branded types for units
 */

import type { Brand } from "@pdfking/tfunc"

/**
 * Size in user unit
 */
export type Distance = Brand<number, "Distance">

/**
 * Size in pixels
 */
export type Pixel = Brand<number, "Pixel">

export type Percentage = Brand<number, "Percentage">

export type Degree = Brand<number, "Degree">

export type Radian = Brand<number, "Radian">
